module.exports = __webpack_public_path__ + "static/media/1POLICY12.0112ede0.jpg";